import React, { useEffect, useContext } from "react";
import AppContext from "../../util/AppContext";
import Carousel from "../Carousel/Carousel";
import GotQueries from "../GotQueries/GotQueries";
import "./RevirtClub.css";

const RevirtClubLanding = () => {
  const myContext = useContext(AppContext);

  useEffect(() => {
    // setting first section height as full view screen
    document.getElementsByClassName('first')[0].style.height = `calc(${myContext.windowHeight}px - 64px)`

    // setting hero section height 
    const ele = document.getElementById('hero-container-fluid');
    const height = myContext.windowHeight - (myContext.navbarHeight);
    ele.style.height = `${height}px`

    // 

  }, [])

  return (
    <div className="section first">
      <div className="container-fluid revirtclubcontainerfluid" id="hero-container-fluid">
        <div className="container revirtclubcontainer" id='hero-container'>
          <div className="row justify-content-center">
            <div
              className="col-xl-6 col-lg-8 col-md-12 col-sm-12 col-12">
              <div>
                <div className="badge">New</div>
                <p className="joinrevirtclub">
                  join
                  <span className="joinrevirtclubbold"> revirt club </span>
                  in minutes
                </p>
                <p className="joinrevirtclub-description">
                  <span className="joinrevirtclub-descriptionbold">
                    revirt.club is an exclusive community of college clubs & its students
                  </span>
                  <br />
                  to network with like minded individuals and learn
                  skills from industry experts at the same time at the same time
                </p>
                <button className="join-telegram">join telegram</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Carousel mode='light' />
    </div>
  );
};

export default RevirtClubLanding;


